import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class LinkedEntitiesService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Create a linkedEntities entry
	 * @param {object} linkedEntities -- linkedEntities data. Ex: { "type": "manually-assigned-camera", "entities": [{"type": "camera", "id": "12343"}, {"type": "shape", id: "4352"}]}
	 * @param {function} callback
	 */
	create(linkedEntities, callback) {
		const url = "/ecosystem/api/linkedEntities";
		const body = JSON.stringify({
			linkedEntities
		});
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Delete a linkedEntities relation
	 * @param {string} entities -- The array of entities whose relation you want to delete Ex: [{"type": "camera", "id": "12343"}, {"type": "shape", id: "4352"}]
	 * @param {string} type -- The type of the relation Ex: "manually-assigned-camera"
	 * @param {function} callback
	 */
	delete(entities, type, callback) {
		const url = "/ecosystem/api/linkedEntities";
		const body = JSON.stringify({
			entities,
			type
		});
		this._restClient.exec_put(url, body, callback);
	}

	subscribeLinkedEntities(entityId, entityType, linkType, callback) {
		const args = {
			entityType,
			entityId,
			linkType
		};
		return this._rc.subscribe("ecosystem", "/linkedEntities", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
}
